@if (isRmbRmc && exported) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <p class="person-label">{{ selectedIndividual | fullname }}</p>
</div>
}<br />
<nh-form
  [formGroup]="getForm()"
  [mode]="mode"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  (validate)="onValidate($event)"
  class="label-section"
  [topLevelName]="'tr'"
  individualQuestion="{{ 'TRANSFERED_INDIV_QUES' | globalTranslate }}"
  [individualQuestionAria]="this.individualQuestionAria"
  topLevelQuestion="{{ 'TRANSFERED_TOPLEVEL_QUES' | globalTranslate }}"
  [popupText]="'TRANSFERED_TOPLEVEL_POPUP' | globalTranslate"
>
  <section [formGroup]="getControl('data')">
    @if (this.translatedLang === 'en') {
    <h1 class="section-header">
      {{ "TRANSFER_SECTION_HEADER" | globalTranslate }}
    </h1>
    } @if (this.translatedLang !== 'en') {
    <h1 class="section-header">
      Los recursos vendidos, negociados o regalados de
      {{ selectedIndividual | fullname }}
    </h1>
    }
    <hr />
    <nh-field
      id="tr_typeOfAsset"
      label="{{ 'TRANSFERED_STATIC_TEXT1' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }}  <div class=hint>{{
        'IF' | globalTranslate
      }} {{ selectedIndividual | fullname }} {{
        'TRANSFERED_STATIC_TEXT2' | globalTranslate
      }}</div>"
      class="label-section"
    >
      <select
        nhTranslate
        name="typeOfAsset"
        [attr.aria-label]="getTypeOfAssetAriaLabel()"
        [items]="tables.RESOURCETRANSFCATEGORY"
        formControlName="typeOfAsset"
        (change)="typeOfAsset(getControl('data.typeOfAsset'), true)"
        required
      ></select>
    </nh-field>

    <nh-field
      id="tr_specificAsset"
      label="{{ 'TRANSFERED_STATIC_TEXT3' | globalTranslate }} {{
        getValue('data.typeOfAsset').value | globalTranslate
      }} {{ 'TRANSFERED_STATIC_TEXT4' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="specificAsset"
        [attr.aria-label]="
          ('TRANSFERED_STATIC_TEXT3' | globalTranslate) +
          ' ' +
          (getValue('data.typeOfAsset').value | globalTranslate) +
          ' ' +
          ('TRANSFERED_STATIC_TEXT4' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('VEHICLE_STATIC_TEXT3' | globalTranslate)
        "
        [items]="specificAssets"
        formControlName="specificAsset"
        required
      ></select>
    </nh-field>

    <nh-field
      id="tr_assetTransferredTo"
      label="{{ 'TRANSFERED_STATIC_TEXT5' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'TRANSFERED_STATIC_TEXT6' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        nh
        [attr.aria-label]="
          ('TRANSFERED_STATIC_TEXT5' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('TRANSFERED_STATIC_TEXT6' | globalTranslate)
        "
        name="assetTransferredTo"
        formControlName="assetTransferredTo"
        class="form-control"
        maxLength="50"
        required
      />
    </nh-field>

    <nh-field
      id="tr_assetTransferDate"
      label="{{ 'TRANSFERED_STATIC_TEXT7' | globalTranslate }}"
      class="label-section"
    >
      <nh-datepicker>
        <input
          type="text"
          name="assetTransferDate"
          [attr.aria-label]="'TRANSFERED_STATIC_TEXT7' | globalTranslate"
          class="form-control"
          formControlName="assetTransferDate"
          bsDatepicker
          nh
          [minDate]="minimumTransferDateDate"
          [maxDate]="today"
          maxLength="10"
          required
        />
      </nh-datepicker>
    </nh-field>

    <nh-field
      id="tr_valueOfAsset"
      label="{{ 'TRANSFERED_STATIC_TEXT8' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        [content]="'TRANSFERED_STATIC_POPUP' | globalTranslate"
      ></nh-popover>
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          [attr.aria-label]="'TRANSFERED_STATIC_TEXT8' | globalTranslate"
          name="valueOfAsset"
          formControlName="valueOfAsset"
          class="form-control"
          required
        />
      </nh-input-group>
    </nh-field>

    <nh-field
      id="tr_inReturnAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'TRANSFERED_STATIC_TEXT9' | globalTranslate }}
    <div class=hint>{{ 'TRANSFERED_STATIC_TEXT10' | globalTranslate }}</div>"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          [attr.aria-label]="
            ('TRANSFERED_STATIC_TEXT9' | globalTranslate) +
            '' +
            ('TRANSFERED_STATIC_TEXT10' | globalTranslate)
          "
          name="inReturnAmount"
          formControlName="inReturnAmount"
          class="form-control"
        />
      </nh-input-group>
    </nh-field>
  </section>
</nh-form>